// extracted by mini-css-extract-plugin
export default {"container":"Menu_container__9tDYw","overlay":"Menu_overlay__N3fya"};